
export default {
    name: 'rapport-depense-caisse-annulee',
    components: {},
    props: {
        rapport_depenses_caisse_annulees: Array,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, { key: 'montant', label: 'Montant' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            depense_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshDepense()
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshDepense() {
            if (this.rapport_depenses_caisse_annulees) {
                this.depense_len = this.rapport_depenses_caisse_annulees.length
            }
        }
    }
}